import React, { useState } from "react";
import {
	PaymentElement,
	LinkAuthenticationElement,
	useStripe,
	useElements
} from "@stripe/react-stripe-js";
import Modal from "react-modal";
import { captureApi } from "../../../../../crud/checkout.crud";
import Router from "next/router";
import { baseUrl } from "../../../../../config/config";
import Loading from "../../../../../components/Loading";
import GetCurrency from "../../../../../helpers/services";
import { CurrencyWithAmount } from "../../../../../helpers/utils";

export default function StripeCheckoutForm({
	query,
	attendeesDetails,
	reviewDetails,
	eventDetails,
	isWidget,
	setApiLoading,
	amount,
	setOpenPaymentModal,
	teamRegType
}) {
	const stripe = useStripe();
	const elements = useElements();

	const [email, setEmail] = useState(null);
	const [message, setMessage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [paymentCheck, setPaymentCheck] = useState(false);

	const widgetParam = isWidget ? "isWidget=true" : "";
	const isEventWidget =
		eventDetails.event_id === "8c7a09aa-e5be-40e3-82a9-b698e34a30ae" ? true : false;

	const handleSubmit = async e => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setIsLoading(true);
		const eventDet = JSON.stringify(eventDetails);
		sessionStorage.setItem("isPaymentState", eventDet);
		sessionStorage.setItem("teamRegType", teamRegType);

		setPaymentCheck(true);
		const res = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Make sure to change this to your payment completion page
				return_url: "" //`${baseUrl}/checkout/stripe/${eventDetails.event_url}`,
			},
			redirect: "if_required"
		});
		const error = res.error;

		const timer = setInterval(async () => {
			const { paymentIntent, error } = await stripe.retrievePaymentIntent(
				res.paymentIntent.client_secret
			);
			if (error) {
				setPaymentCheck(false);
				clearInterval(timer);
			}
			if (
				paymentIntent &&
				(paymentIntent.status === "succeeded" ||
					paymentIntent.status === "requires_capture")
			) {
				const stripeQuery = {
					payment_intent: paymentIntent.id,
					payment_intent_client_secret: paymentIntent.client_secret,
					redirect_status: "succeeded"
				};
				if (isWidget) stripeQuery.widget = "true";
				setOpenPaymentModal(false);
				clearInterval(timer);
				Router.push({
					pathname: `/checkout/stripe/${eventDetails.event_url}`,
					query: stripeQuery
				});
			} else {
				setPaymentCheck(false);
				clearInterval(timer);
			}
		}, 2000);

		// This point will only be reached if there is an immediate error when
		// confirming the payment. Otherwise, your customer will be redirected to
		// your `return_url`. For some payment methods like iDEAL, your customer will
		// be redirected to an intermediate site first to authorize the payment, then
		// redirected to the `return_url`.
		if (error) {
			if (error.type === "card_error" || error.type === "validation_error") {
				setMessage(error.message);
				setPaymentCheck(false);
				clearInterval(timer);
				sessionStorage.removeItem("isPaymentDone", eventDetails);
			} else {
				setMessage("An unexpected error occurred.");
				setPaymentCheck(false);
				clearInterval(timer);
				sessionStorage.removeItem("isPaymentDone", eventDetails);
			}
		}

		setIsLoading(false);
		setOpenPaymentModal(false);
	};

	const paymentElementOptions = {
		layout: "tabs"
	};

	return (
		<>
			{paymentCheck && (
				<Modal
					isOpen={paymentCheck}
					onRequestClose={() => {}}
					shouldCloseOnOverlayClick={false}
					backdrop="static"
					contentLabel="Subscribe Modal"
					className="payment-check-modal"
					style={{
						backgroundColor: "red"
					}}
				>
					<Loading />
				</Modal>
			)}
			<form id="payment-form" onSubmit={handleSubmit}>
				{/*<LinkAuthenticationElement
        id="link-authentication-element"
        onChange={(e) => {
          reviewDetails[0].email_id
          // console.log('e', e)
          // console.log(' e.target.value', e.target.value)
        }}
      />*/}
				<div className="p-3 mt-1">
					<PaymentElement id="payment-element" options={paymentElementOptions} />
				</div>
				<div className="stripe-modal-footer">
					<div className="d-flex justify-content-between align-items-center">
						<div className="price-text">
							<CurrencyWithAmount
								/*fontSize="12px"*/
								currencyName={eventDetails.currency_name}
								number={amount}
							/>
						</div>
						<div>
							<button
								className="btn payButton"
								disabled={isLoading || !stripe || !elements}
								id="submit"
								style={{
									background: `${query.btnBg ? `#${query.btnBg}` : "#572148"}`
								}}
								type="submit"
							>
								<span id="button-text">
									{isLoading ? (
										<div
											className="spinner-border spinner-border-sm"
											id="spinner"
										/>
									) : (
										"Pay Now"
									)}
								</span>
							</button>
						</div>
					</div>
					<div className="d-flex justify-content-center align-items-center">
						<p className="mb-0 mt-2">
							{/*<span className="stripe-logo-text">Secured by</span>*/}
							<a href="https://stripe.com/" target="_blank" rel="noreferrer">
								<img
									src="/img/PoweredByStripe-blurple.svg"
									alt=""
									className="stripe-logo"
								/>
							</a>
						</p>
					</div>
					{/* Show any error messages */}
					{message && (
						<div
							id="payment-message"
							className="d-flex justify-content-center align-items-center"
						>
							{message}
						</div>
					)}
				</div>
			</form>
			<style jsx>{`
				.payButton {
					// background: #572148;
					color: #fff;
					border-radius: 4px;
					cursor: pointer;
					box-shadow: 0px 4px 5px rgb(0 0 0 / 15%);
					transition: all 0.2s;
				}
				.payButton:hover {
					box-shadow: 0px 0px 5px #fb5850;
				}
				.payButton:active {
					box-shadow: none;
					transition:
						color 0.15s ease-in-out,
						background-color 0.15s ease-in-out,
						border-color 0.15s ease-in-out,
						box-shadow 0.15s ease-in-out;
				}
				.stripe-modal-footer {
					margin-top: 20px;
					box-shadow: 0px -2px 16px rgba(0, 0, 0, 0.1);
					padding: 10px 20px 10px;
				}
				.price-text {
					font-family: "Prompt";
					font-style: normal;
					font-weight: 500;
					font-size: 24px;
					line-height: 12px;
				}
				.stripe-logo-text {
					font-family: "Prompt";
					font-style: normal;
					font-weight: 500;
					font-size: 12px;
					line-height: 22px;
					color: #646fde;
				}
				.stripe-logo {
					margin-top: 4px;
					width: 150px;
				}
				#payment-message {
					color: #df1b41;
					font-size: 16px;
					line-height: 20px;
					padding-top: 12px;
					text-align: center;
				}

				#payment-element {
					margin-bottom: 24px;
				}

				@media only screen and (max-width: 600px) {
					form {
						// width: 80vw;
						min-width: initial;
					}
				}
			`}</style>
		</>
	);
}
